export const initSatismeter = (uid: string) => {
  (function () {
    window.satismeter =
      window.satismeter ||
      function () {
        (window.satismeter.q = window.satismeter.q || []).push(arguments);
      };
    // @ts-ignore
    window.satismeter.l = 1 * new Date();
    const script = document.createElement('script');
    // @ts-ignore
    const parent = document.getElementsByTagName('script')[0].parentNode;
    // @ts-ignore
    script.async = 1;
    script.src = 'https://app.satismeter.com/satismeter.js';
    // @ts-ignore
    parent.appendChild(script);
  })();

  window.satismeter({
    writeKey: 'V5273QvaVU3EpiVkQp1HjcMhctJ69w2U',
    userId: uid,
  });
};
